import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const InEligibleLoans = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M13.825 11.592H11.45l-.95-7.703a8.676 8.676 0 0 1 5.7 0c-.95 3.37-1.425 4.814-2.375 7.703Z"
      fill="#8FBEFF"
    />
    <Path
      d="m14.3 10.143-.475 1.444H11.45l-.95-7.703a8.709 8.709 0 0 1 2.85-.482h.119l.831 6.74Z"
      fill="#467AC2"
    />
    <Path
      d="M7.175 11.592H9.55l.95-7.703a8.676 8.676 0 0 0-5.7 0c.95 3.37 1.425 4.814 2.375 7.703Z"
      fill="#8FBEFF"
    />
    <Path
      d="M8.125 9.666c-.789-2.407-1.25-3.803-1.929-6.134-.474.08-.941.199-1.396.357.95 3.37 1.425 4.814 2.375 7.703H9.55l.237-1.926H8.125Z"
      fill="#467AC2"
    />
    <Path
      d="M12.4 9.185H8.6L7.65 1.48a8.676 8.676 0 0 1 5.7 0l-.95 7.704Z"
      fill="#8FBEFF"
    />
    <Path
      d="M10.866 6.777a.943.943 0 0 1-.633-.238.967.967 0 0 1-.317-.604l-.594-4.853a8.98 8.98 0 0 0-1.672.4l.95 7.703h3.8c.1-.804.2-1.604.294-2.408h-1.828Z"
      fill="#467AC2"
    />
    <Path
      d="M20 21.943c0 5.296-4.275 5.055-9.5 5.055s-9.5.24-9.5-5.055c0-5.296 4.275-12.758 9.5-12.758S20 16.647 20 21.943Z"
      fill="#8FBEFF"
    />
    <Path
      d="M19.753 23.869c-.979 3.322-4.745 3.129-9.253 3.129-5.225 0-9.5.24-9.5-5.055 0-4.593 3.163-10.76 7.41-12.364-2.185 2.643-3.61 6.408-3.61 9.475 0 5.296 4.275 5.055 9.5 5.055a34.782 34.782 0 0 0 5.453-.24Z"
      fill="#467AC2"
    />
    <Path
      d="M14.3 8.222H6.7a.957.957 0 0 0-.95.963c0 .531.425.962.95.962h7.6c.525 0 .95-.43.95-.962a.956.956 0 0 0-.95-.963Z"
      fill="#F2E6C7"
    />
    <Path
      d="M7.65 8.222H6.7a.944.944 0 0 0-.672.282.97.97 0 0 0 0 1.361c.178.181.42.282.672.282h7.6a.944.944 0 0 0 .672-.282.97.97 0 0 0 .278-.68H8.6a.944.944 0 0 1-.672-.282.97.97 0 0 1-.278-.681Z"
      fill="#E2CA96"
    />
    <Path
      d="M24.414 27H12.218c-.79 0-1.527-.425-1.922-1.11a2.227 2.227 0 0 1 0-2.218l6.098-10.563A2.226 2.226 0 0 1 18.316 12c.79 0 1.527.425 1.922 1.11l6.098 10.561a2.227 2.227 0 0 1 0 2.22A2.226 2.226 0 0 1 24.414 27Z"
      fill="#fff"
    />
    <Path
      d="M26.336 25.89a2.227 2.227 0 0 0 0-2.219L20.238 13.11A2.226 2.226 0 0 0 18.316 12v15h6.098c.79 0 1.527-.425 1.922-1.11Z"
      fill="#fff"
    />
    <Path
      d="M12.218 25.58a.801.801 0 0 1-.692-1.199l6.098-10.561a.801.801 0 0 1 .692-.4c.284 0 .55.153.692.4l6.098 10.562a.802.802 0 0 1 0 .798.802.802 0 0 1-.692.4H12.218Z"
      fill="#FF9595"
    />
    <Path
      d="M25.106 25.18a.802.802 0 0 0 0-.798L19.008 13.82a.801.801 0 0 0-.692-.4v12.16h6.098c.284 0 .55-.153.692-.4Z"
      fill="#F46262"
    />
    <Path
      d="M18.316 23.958a.71.71 0 0 1-.71-.71v-.38a.71.71 0 1 1 1.42 0v.38a.71.71 0 0 1-.71.71Z"
      fill="#fff"
    />
    <Path
      d="M19.026 23.247v-.38a.71.71 0 0 0-.71-.71v1.8a.71.71 0 0 0 .71-.71Z"
      fill="#FFE7E7"
    />
    <Path
      d="M18.316 20.915a.71.71 0 0 1-.71-.71v-2.918a.71.71 0 1 1 1.42 0v2.918a.71.71 0 0 1-.71.71Z"
      fill="#fff"
    />
    <Path
      d="M19.026 20.205v-2.918a.71.71 0 0 0-.71-.71v4.338a.71.71 0 0 0 .71-.71Z"
      fill="#FFE7E7"
    />
  </Svg>
)

export default InEligibleLoans
